// extracted by mini-css-extract-plugin
export default {"container":"p7e3g","icon":"hBWEe"};